<template>
    <div class="mini-fate-fortune-panel" v-bind:class="{'mini-ffp-1-3': miniShowLines == 0, 'mini-ffp-2-3': miniShowLines == 1}">
        <fate-panel
            v-bind:hideSideBar="false" 
            v-bind:parentFrom="'mini'"
            v-bind:fateData="miniFateListData" 
            v-bind:fateSideData="miniFateSideListData" 
            v-bind:fateInfo="miniFateInfo"
            v-bind:siZhuLiuNianReverse="parseInt(settingConfigData.sizhuGeShi) == 1"
            v-bind:sideCloseFunc="clickSideClose">
        </fate-panel>
        
        <fortune-panel
            v-bind:fateSideData="miniFateSideListData"
            v-bind:fortuneTitle="miniFortuneTitle"
            v-bind:fortuneData="miniFortuneData"
            v-bind:transitioned="false"
            v-bind:parentFrom="'mini'"
            v-bind:showType="miniShowType"
            v-bind:showTable="miniShowTable"
            v-bind:showLines="miniShowLines"
            v-bind:showFortuneLines="miniShowLines"
            v-bind:arrowFunc="clickFortuneArrow"
            v-bind:showLeftArrow="miniShowLeftArrow"
            v-bind:showRightArrow="miniShowRightArrow"
            v-bind:liunianData="miniLiunianData"
            v-bind:liuyueData="miniLiuyueData"
            v-bind:liuriData="miniLiuriData"
            v-bind:liushiData="miniLiushiData"
            v-bind:itemFunc="clickFortuneItem"
            v-bind:moveLeftFunc="fortuneMoveLeft"
            v-bind:moveRightFunc="fortuneMoveRight"
            v-bind:scrollLeftFunc="fortuneScrollLeft"
            v-bind:scrollRightFunc="fortuneScrollRight"
            v-bind:scrollBackFunc="fortuneScrollBack">
        </fortune-panel>
    </div>
</template>

<script>
import FatePanel from './FatePanel.vue'
import FortunePanel from './FortunePanel.vue'
import { COMMENT_DOM, DISCUSS_DOM, FAMOUS_DOM } from '../../modules/dom'
export default {
    name: 'MiniFateFortunePanel',
    components: {FatePanel, FortunePanel},
    props: [
        'fromPage',
        'fortuneItemFunc',
        'fateSideCloseFunc',
        'miniFortuneScrollLeft',
        'miniFortuneScrollRight'
    ],
    computed: {
        settingConfigData() {
            return this.$store.state.setting.settingConfigData;
        },
        miniFateInfo(){
            return this.$store.state.minifatefortune.fateInfo;
        },
        miniFateListData(){
            var miniFateListData = [].concat(this.$store.state.minifatefortune.fateListData);
                miniFateListData = parseInt(this.settingConfigData.nianyueRishi) == 0 ? miniFateListData : miniFateListData.reverse();
            return miniFateListData;
        },
        miniFateSideListData(){
            var miniFateSideListData = [].concat(this.$store.state.minifatefortune.fateSideListData);
                miniFateSideListData = parseInt(this.settingConfigData.nianyueRishi) == 0 ? miniFateSideListData : miniFateSideListData.reverse();
            return miniFateSideListData;
        },
        miniFortuneTitle() {
            return this.$store.state.minifatefortune.fortuneTitle;
        },
        miniFortuneData() {
            return this.$store.state.minifatefortune.fortuneListData;
        },
        miniShowLeftArrow() {
            return this.$store.state.minifatefortune.showLeftArrow;
        },
        miniShowRightArrow() {
            return this.$store.state.minifatefortune.showRightArrow;
        },
        miniShowTable() {
            return this.$store.state.minifatefortune.showTable;
        },
        miniShowLines() {
            return this.$store.state.minifatefortune.showLines;
        },
        miniShowType() {
            return this.$store.state.minifatefortune.showType;
        },
        miniLiunianData() {
            return this.$store.state.minifatefortune.liunianListData;
        },
        miniLiuyueData() {
            return this.$store.state.minifatefortune.liuyueListData;
        },
        miniLiuriData() {
            return this.$store.state.minifatefortune.liuriListData;
        },
        miniLiushiData() {
            return this.$store.state.minifatefortune.liushiListData;
        },
    },
    data() {
        return {
            clickLock: false,
            curShowLines: 0
        }
    },
    mounted() {
        this.curShowLines = this.miniShowLines;
    },
    methods: {
        clickSideClose(data) {
            this.$store.dispatch("minifatefortune/deleteMiniFateSide", data);
            this.updateFortunePanel();
            // this.updateDOM();
            var me = this;
            setTimeout(() => {
                if(data.type == 'dayun') {
                    me.$bus.emit('updateFortuneDom');
                }else if(data.type == 'liunian') {
                    me.$bus.emit('updateFortuneLiuNian');
                }
            }, 20);

            // 添加联动事件
            if(typeof(this.fateSideCloseFunc) == 'function') {
                this.fateSideCloseFunc(data, this.miniFateSideListData);
            }
        },
        clickFortuneItem(data) {
            // 增加点击时间的锁定
            if(this.clickLock) { return; }
            var me = this; setTimeout(() => { me.clickLock = false }, 300);
            this.clickLock = true;

            this.$store.dispatch("minifatefortune/addMiniFateSide", data);
            this.updateFortunePanel();
            // this.updateDOM();

            switch(data.type){
                case 'dayun':
                    this.$store.dispatch('minifatefortune/showMiniLiuNian', data);
                    break;
                case 'liunian':
                    this.$store.dispatch('minifatefortune/showMiniLiuYue', data.year);
                    break;
                case 'liuyue':
                    this.$store.dispatch('minifatefortune/showMiniLiuRi', data.time);
                    break;
                case 'liuri':
                    this.$store.dispatch('minifatefortune/showMiniLiuShi', data.g);
                    break;
                default:
                    break;
            }

            // 添加联动事件
            if(typeof(this.fortuneItemFunc) == 'function') {
                this.fortuneItemFunc(data, this.miniFateSideListData);
            }
        },
        clickFortuneArrow() {
            this.$store.dispatch('minifatefortune/toggleArrowChangeShowLines');
            this.updateDOM();
        },
        updateDOM() {
            // 如果迷你命盘的行数并未改变，则返回;
            if(this.miniShowLines == this.curShowLines) { return; }
            // 更新dom
            console.log('updateDOM-------', this.curShowLines, this.miniShowLines, this.fromPage)
            this.curShowLines = this.miniShowLines;
            if(this.fromPage == 'Comment') {
                COMMENT_DOM.updateCommentFormStyle();
            }
            if(this.fromPage == 'Discuss') {
                DISCUSS_DOM.updateDiscussFormStyle();
                this.$bus.emit('initDiscussHistoryList');
            }
            if(this.fromPage == 'FamousPediaRead' || this.fromPage == 'FamousPediaEdit') {
                setTimeout(() => {
                    FAMOUS_DOM.updateFamousFormStyle();
                }, 20);
            }
        },
        updateFortunePanel() {
            var liunian = document.getElementById('liunian'),
                liuyue = document.getElementById('liuyue'),
                liuri = document.getElementById('liuri'),
                liushi = document.getElementById('liushi');
            if(liunian) { liunian.style = ''; }
            if(liuyue) { liuyue.style = ''; }
            if(liuri) { liuri.style = ''; }
            if(liushi) { liushi.style = ''; }
        },
        fortuneMoveLeft(params) {
            this.$store.dispatch('minifatefortune/addFortuneListData', {
                type: 'previous',
                dataType: this.miniShowType,
                firstCb: params.firstCb,
                cb: params.cb
            });
        },
        fortuneMoveRight(params) {
            this.$store.dispatch('minifatefortune/addFortuneListData', {
                type: 'next',
                dataType: this.miniShowType,
                firstCb: params.firstCb,
                cb: params.cb
            });
        },
        fortuneScrollBack(type) {
            var me = this;
            this.$store.dispatch('minifatefortune/resetFortuneListData', {
                type: type,
                dataType: this.miniShowType,
            })
        },
        fortuneScrollLeft() {
            var me = this;
            this.$store.dispatch('minifatefortune/getNewFortuneItemData', {
                type: 'previous',
                dataType: this.miniShowType,
                cb: function(data) {
                    me.clickFortuneItem(data);
                }
            });
        },
        fortuneScrollRight() {
            var me = this;
            this.$store.dispatch('minifatefortune/getNewFortuneItemData', {
                type: 'next',
                dataType: this.miniShowType,
                cb: function(data) {
                    me.clickFortuneItem(data);
                }
            })
        }
    }
}
</script>